import { Network } from "../common/Network";
export var FlightApi;
(function (FlightApi) {
    async function getFlightDetail(serverId, flightId) {
        return await Network.get(`servers/${serverId}/flights/${flightId}`);
    }
    FlightApi.getFlightDetail = getFlightDetail;
    async function getFlightKml(serverId, flightId) {
        return await Network.get(`servers/${serverId}/flights/${flightId}/kml`);
    }
    FlightApi.getFlightKml = getFlightKml;
})(FlightApi || (FlightApi = {}));
